module.exports = __webpack_public_path__ + "static/images/smartspot-performance-nl-NL.796b2596f73503d80dace41b88ce069f.png";